import { Skeleton } from '@mui/material';
import { Stack } from 'shared/mui/Stack/Stack';

export const ProviderAccountsFormSkeleton = () => {
  return (
    <Stack gap="4px" paddingTop="24px" sx={{ marginBottom: '14px' }} width="100%">
      <Skeleton
        height={30}
        sx={{ gridColumn: '1 / span 2', borderRadius: 1 }}
        variant="rounded"
        width={160}
      />
      {Array.from({ length: 2 }).map((_, i) => (
        <Stack direction="row" gap="24px" key={i}>
          <Skeleton height={60} width="100%" />
          <Skeleton height={60} width="100%" />
        </Stack>
      ))}
    </Stack>
  );
};
